module.exports = __webpack_public_path__ + "static/media/xp-banner4.df777729.jpg";